<template>
  <p class="wrap"><span>{{ i18n.lbl_time_to_refund() }}</span>&nbsp;&nbsp;<span class="wait-text">{{ timerDisplay }}</span></p>
</template>

  <script>
  import { i18n } from '@js/i18n'
  export default {
    name: 'Timer',
    props: {
      timer: {
        type: [String, Number, Date],
        required: true
      }
    },
    emits: ['action'],
    data () {
      return {
        i18n,
        localTimer: {
          minutes: 0,
          seconds: 0,
          hours: 0
        },
        interval: null,
        actionEmitted: false
      }
    },
    created () {
      this.updateTimer()
      this.startTimer()
    },
    watch: {
      timer () {
        this.actionEmitted = false
        this.updateTimer()
      }
    },
    beforeUnmount () {
      this.stopTimer()
    },
    computed: {
      timerDisplay () {
        return `${this.formatTime(this.hours)}:${this.formatTime(this.minutes)}:${this.formatTime(this.seconds)}`
      },
      minutes () {
        return this.localTimer.minutes
      },
      hours () {
        return this.localTimer.hours
      },
      seconds () {
        return this.localTimer.seconds
      }
    },
    methods: {
      normalizeTargetDate (targetTime) {
        if (targetTime instanceof Date) return targetTime
        if (typeof targetTime === 'number') return new Date(targetTime)

        if (typeof targetTime === 'string') {
          let fixedStr = targetTime
          const match = targetTime.match(/T(\d{3,}):/)
          if (match) {
            const hour = parseInt(match[1], 10)
            fixedStr = targetTime.replace(/T\d{3,}:/, `T${hour.toString().padStart(2, '0')}:`)
          }
          return new Date(fixedStr)
        }

        return new Date(NaN)
      },
      formatTime (time) {
        return time < 10 ? `0${time}` : time
      },
      updateTimer () {
        const targetDate = this.normalizeTargetDate(this.timer)
        const targetTimestamp = targetDate.getTime()

        if (!Number.isFinite(targetTimestamp)) {
          this.stopTimer()
          return
        }

        const diff = Math.max(0, targetTimestamp - Date.now())

        const totalSeconds = Math.floor(diff / 1000)
        const seconds = totalSeconds % 60
        const totalMinutes = Math.floor(totalSeconds / 60)
        const minutes = totalMinutes % 60
        const hours = Math.floor(totalMinutes / 60)

        this.localTimer = { hours, minutes, seconds }

        if (diff <= 0 && !this.actionEmitted) {
          this.actionEmitted = true
          this.stopTimer()
          this.$emit('action')
        }
      },
      startTimer () {
        this.stopTimer(false)
        this.interval = setInterval(() => {
          this.updateTimer()
        }, 1000)
      },
      stopTimer (resetLocalTimer = true) {
        if (this.interval) {
          clearInterval(this.interval)
          this.interval = null
        }
        if (resetLocalTimer) {
          this.localTimer = {
            minutes: 0,
            seconds: 0,
            hours: 0
          }
        }
      }
    }
  }
  </script>

  <style lang="scss" scoped>
  .wrap {
    max-width: 600px;
    font-size: 18px;
  }
  .wait-text {
    font-weight: bold;
    display: inline-block;
  }
  </style>



// WEBPACK FOOTER //
// src/vue/app/timer/RefundTimer.vue